import { put, call, take, fork } from 'redux-saga/effects'
import { landingPagePatchService } from 'src/api/collection'
import { patchCollectionLandingPageSuccess } from 'src/reducers/collection/action'
import { PATCH_COLLECTION_LANDING_PAGE } from 'src/reducers/collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* landingPageCollectionPatchFlow(payload) {
  try {
    const { id, data, callback } = payload
    yield call(landingPagePatchService, id, data)
    yield put(patchCollectionLandingPageSuccess(data, id))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* landingPageCollectionWatcher() {
  while (true) {
    const action = yield take(PATCH_COLLECTION_LANDING_PAGE)
    const { payload } = action

    yield fork(generalSaga, landingPageCollectionPatchFlow, payload)
  }
}
